"use client";

import { useState } from "react";
import Accordion from "../accordian/accordion";
// import Accordion from "../Accordian/accordion";

const Faq = ({ tripFaq }) => {
  // const [curr, setCurr] = useState(0);
  return (
    <div className="sm:flex hidden flex-col lg:flex-row bg-[#fffcf2] gap-5 px-4 sm:px-8 lg:px-28">
      <div className="flex flex-col lg:w-[50%] lg:items-start items-center justify-center  lg:text-start text-center">
        <div className="mb-2 text-[#5254DB] font-semibold">FAQS</div>
        <div
          className={`rounded-[18px] text-[20px] lg:text-[25px] font-[700] uppercase text-nowrap`}
          // key={index}
        >
          Questions on your mind?
          <br />
          Don’t worry <br /> we’ve got the answers!
        </div>
      </div>
      <div className="w-full ">
        <Accordion />
      </div>
    </div>
  );
};
export default Faq;
